import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=03ea305d&scoped=true&lang=pug&"
import script from "./FooterNav.vue?vue&type=script&lang=js&"
export * from "./FooterNav.vue?vue&type=script&lang=js&"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=03ea305d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ea305d",
  null
  
)

export default component.exports